<template>
  <div class="stidoc">
    <img class="stidoc_img" :src="img.stidoc_img">
  </div>
</template>

<script>
  import content from '../../../api/content';
  export default {
    data () {
      return {
        img:{
          stidoc_img: require('../../../assets/img/subaru/stidoc_img.jpg')
        }
      }
    },
    created () {

    },
    methods: {

    }
  };
</script>

<style lang="scss">
.stidoc {
  overflow-x: false;
  font-size: 0;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none;   /* Chrome/Safari/Opera */
    -khtml-user-select: none;     /* Konqueror HTML */
    -moz-user-select: none;       /* Firefox */
    -ms-user-select: none;        /* Internet Explorer/Edge */
    user-select: none;     
    .stidoc_img{
      width: 100%;
      height: auto;
      object-fit : cover;
      display: block;
      vertical-align:middle;
    }
  }
</style>
